<div class="container-fluid">
    <div class="row info-modal-header">
      <div class="col-11 modal-header-title">
        <h1 mat-dialog-title class="title">Privacy</h1>
      </div>
      <div class="col-1">
        <button mat-button (click)="closeModal()"><i class="fa fa-window-close fa-lg"></i></button>
      </div>
    </div>
    <mat-dialog-content>
      <h6><strong>DISCLAIMER CEDLAB</strong></h6>
      <div [innerHTML]="disclaimer"></div>
    </mat-dialog-content>
  </div>
  